/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
  <v-row>
         <!-- ======================= NOVA CATEGORIA ============================ -->
             <template>
              <v-row justify="center">
                <v-dialog v-model="showLoteModal" persistent max-width="600px">
  <v-form
    ref="formLote"
    v-model="validLote"
    lazy-validation
  >
                  <v-card>
                    <v-card-title style="background-color:#006699;color:white;">
                      <span class="headline">Nova Descricao</span>
                    </v-card-title>
                    <v-alert v-model="alertLote" type="success">
                    Descrição cadastrada com sucesso
                  </v-alert>
                    <v-card-text>
                      <v-container>

                        <v-row>
                             <v-col cols="12" sm="6" md="12">
                                <v-text-field  v-model="editedItemCategoria.descricao" :rules="ruleRequired"  label="Forneça a descrição do movimento"></v-text-field>
                            </v-col>
                        </v-row>

                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!validLote" @click="saveDescricao()">Guardar</v-btn>
                      <v-btn    @click="showLoteModal = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
  </v-form>
                </v-dialog>
              </v-row>
              </template>

         <!-- ==================== FIM  =========================== -->

         <!-- ======================= NOVA SUBCATEGORIA ============================ -->
             <template>
              <v-row justify="center">
                <v-dialog v-model="dialogSubcategoria" persistent max-width="600px">
  <v-form
    ref="formLote"
    v-model="validLote"
    lazy-validation
  >
                  <v-card>
                    <v-card-title style="background-color:#006699;color:white;">
                      <span class="headline">Nova Fonte</span>
                    </v-card-title>
                    <v-alert v-model="alertLote" type="success">
                    Fonte cadastrada com sucesso
                  </v-alert>
                    <v-card-text>
                      <v-container>
                        <v-row>
                             <v-col cols="12" sm="6" md="12">
                                <v-text-field  v-model="editedItemCategoria.subcategoria" :rules="ruleRequired"  label="Forneça a Fonte"></v-text-field>
                            </v-col>
                        </v-row>

                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!validLote" @click="saveSubcategoria()">Guardar</v-btn>
                      <v-btn    @click="FecharSubDialog">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
  </v-form>
                </v-dialog>
              </v-row>
              </template>
         <!-- ==================== FIM NOVO LOTE =========================== -->
  </v-row>
  <v-overlay :value="overlay">
      <v-progress-circular color="green" indeterminate size="70"></v-progress-circular>
    </v-overlay>
  <v-row>
      <v-card style="margin:auto;" width="1200px" >
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
        <v-card-title style="font-size:20px;background-color:#006699;color:white;">
           <span>Cadastro - Outras Entradas</span>
          <div style="font-size:15px;margin-left:50px;" v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
          <v-alert
              v-model="alert"
              dismissible
              :type="alertType"
              border="left"
              :icon="iconAlert"
              transition="scale-transition"
              :style="colorAlert"
              elevation="2"
              colored-border
            >
            {{msgAlert}}
          </v-alert>
        </v-card-title>
          <v-data-table
          :headers="headers"
          :items="Produtos"
          :search="search"
            hide-default-footer
          >
           <template v-slot:item.codigo="{ item }">
              <span>{{(Produtos.indexOf(item) + 1)}}</span>
           </template>
           <template v-slot:item.movimento="{ item }">
              <v-text-field v-model="Produtos[Produtos.indexOf(item)].movimento"  background-color="#ffff99"  :rules="ruleRequired" filled label="Movimento"></v-text-field>
           </template>
           <template v-slot:item.data="{ item }">
              <v-text-field v-model="Produtos[Produtos.indexOf(item)].data"  background-color="#ffff99"  :rules="ruleRequired" filled label="Data"></v-text-field>
           </template>
           <template v-slot:item.descricao="{ item }">
                <v-combobox
                  v-model="Produtos[Produtos.indexOf(item)].categoria"
                  :items="Categoriadispesas"
                  :search-input.sync="search"
                  hide-selected
                  filled
                  background-color="#ffff99"
                  item-text="descricao"
                  item-value="descricao"
                  label="Selecione"
                  small-chips
                  :rules="ruleRequired"
                  @click="Listagem_descricao()"
                  @change="SelecionaCategoria(Produtos.indexOf(item))"
                >
                <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.icone"
                        color="indigo"
                        class="headline font-weight-light white--text"
                      >
                        <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                </v-combobox>
           </template>
           <template v-slot:item.fonte="{ item }">
                 <v-combobox
                  v-model="Produtos[Produtos.indexOf(item)].fonte"
                  :items="fontes"
                  :search-input.sync="search"
                  hide-selected
                  filled
                  background-color="#ffff99"
                  item-text="descricao"
                  item-value="descricao"
                  label="Selecione"
                  small-chips
                  :rules="ruleRequired"
                  @click="Listagem_Fontes()"
                  @change="SelecionaSubCategoria(Produtos.indexOf(item))"
                >
                <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.icone"
                        color="indigo"
                        class="headline font-weight-light white--text"
                      >
                        <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                </v-combobox>
           </template>
            <template v-slot:item.formaPagamento="{ item }">
              <v-combobox
                  v-model="Produtos[Produtos.indexOf(item)].formaPagamento"
                  :items="formaPagamentos"
                  hide-selected
                  filled
                  background-color="#ffff99"
                  item-text="descricao"
                  item-value="descricao"
                  label="Selecione"
                  small-chips
                  :rules="ruleRequired"
                  @click="Listagem_formasPagamento()"
                  @change="SelecionaFormaPagamento(Produtos.indexOf(item))"
                >
                </v-combobox>
           </template>
           <template v-slot:item.Banco="{ item }">
             <v-combobox
                  v-model="Produtos[Produtos.indexOf(item)].banco"
                  :items="bancos"
                  hide-selected
                  :disabled="disabilitaBanco"
                  filled
                  :background-color="cor"
                  item-text="nome"
                  item-value="nome"
                  label="Selecione"
                  small-chips
                  :rules="ruleRequiredBanco"
                  @click="Listagem_Bancos()"
                  @change="SelecionaBanco(Produtos.indexOf(item))"
                >
                <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.icone"
                        color="indigo"
                        class="headline font-weight-light white--text"
                      >
                        <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                </v-combobox>
           </template>
           <template v-slot:item.conta="{ item }">
             <v-combobox
                  v-model="Produtos[Produtos.indexOf(item)].conta"
                  :items="contas"
                  hide-selected
                  :disabled="disabilitaBanco"
                  filled
                  :background-color="cor"
                  item-text="numeroConta"
                  item-value="numeroConta"
                  label="Selecione"
                  small-chips
                  :rules="ruleRequiredBanco"
                  @click="Listagem_tiposDescontos_recentes()"
                >
                </v-combobox>
           </template>
           <template v-slot:item.custo="{ item }">
              <v-text-field  v-model="Produtos[Produtos.indexOf(item)].custo" background-color="#ffff99" v-money="money"  filled label="Custo"></v-text-field>
           </template>
           <template v-slot:item.delete="{ item }">
              <v-btn small color="#de143c" fab style="color:white;margin-top:-24px;" @click="remover(Produtos.indexOf(item))"><v-icon>delete</v-icon></v-btn>
           </template>
          </v-data-table>
          <v-row>
                 <v-col md="5">
                 </v-col>
                 <v-col md="3"></v-col>
                 <v-col md="4">
                    <span style="margin-left:64px;">Total Geral: <v-chip color="#006699" style="color:white;">{{ObterValorFormatado(totalGeral)}} </v-chip></span>
                 </v-col>
              </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  color="#08cc0b" @click="AddTabela()" :disabled="!valid " fab style="color:white;margin-top:-20px;"><v-icon>add</v-icon></v-btn>
            <!-- :disabled="linhasVaziasEncontradas || !Produtos.length || TotalInvalido || mesmoLote || totalGeral !== utilitariosData.MoneyValueToInteger(valorFatura)" -->
           <v-btn style="margin-top:-5px;margin-right:5px;" color="primary" :disabled="!valid || !Produtos.length" @click="Concluir()" >Submeter</v-btn>
          </v-card-actions>
  </v-form>
      </v-card>
  </v-row>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    money: {
      decimal: ',',
      thousands: '.',
      suffix: ' Kz',
      precision: 2,
      masked: false
    },
    overlay: false,
    utilitariosData: utilitarios,
    contas: [],
    Categoriadispesas: [],
    subcategorias: [],
    formaPagamentos: [],
    disabilitaBanco: true,
    cor: '#ccc',
    pkCategoria: null,
    Produtos: [],
    tiposDispesas: [],
    dialogSubcategoria: false,
    showLoteModal: false,
    tipos: [],
    bancos: [],
    isLoading_: false,
    isLoadingFt: false,
    isLoadingForn: false,
    validLote: true,
    isLoadingF: false,
    alertLote: false,
    search: '',
    searchForn: [],
    searchNF: '',
    categoriaSelecionada: null,
    menuFab: null,
    menuExp: null,
    datasExpiracao: [],
    dataFabrico: '',
    dataExpiracao: '',
    dataCompra: '',
    valid: true,
    valid1: true,
    files: [],
    fontes: [],
    taxa_iva: [],
    faturas: [],
    menuExpss: [],
    fornecedores: [],
    valorFatura: 0,
    descricaoUnidade: [],
    stockGuardado: [],
    descricao_isencao_iva: [],
    descricao_isencao_ivaprecoFiltered: [],
    taxa_ivaPrecoSelected: null,
    dataCompraSelected: null,
    disabilita_ivaPreco: true,
    produtos: [],
    disabilitaDisponivel: true,
    disabilitaQtd: true,
    alert: false,
    iconAlert: 'done',
    alertType: 'success',
    colorAlert: 'color:green;',
    msgAlert: '',
    headers: [
      {
        text: 'N',
        align: 'start',
        sortable: false,
        value: 'codigo'
      },
      { text: '(ano/mês/dia)', value: 'data' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Fonte', value: 'fonte' },
      { text: 'F.Pagamento', value: 'formaPagamento' },
      { text: 'Banco', value: 'Banco' },
      { text: 'Conta', value: 'conta' },
      { text: 'Custo', value: 'custo' },
      { text: 'Deleta', value: 'delete' }
    ],
    headersFatura: [
      {
        text: 'Identificação da Fatura',
        align: 'start',
        sortable: false,
        value: 'Fatura'
      },
      { text: 'Operação', value: 'operacaoStock' },
      { text: 'Data de entrada', value: 'data_' },
      { text: 'Ver Items', value: 'items' },
      { text: 'Restaurar Factura', value: 'restaurar' }
    ],
    operacoesStocks:
    [
      { descricao: 'Entrada de Stock' },
      { descricao: 'Saida de Stock' }
    ],
    disponiblidade:
    [
      { id: 1, descricao: 'Não disponível' },
      { id: 2, descricao: 'Disponível' }
    ],
    lotes: [],
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequiredBanco: [
      value => !!value || 'campo obrigatorio'
    ],
    ruleRequiredMotivo: [value => !!value || 'campo obrigatorio'],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],

    msg: '',
    editedItemCategoria: {
      descricao: '',
      subcategoria: '',
      fkCategoria: ''
    },
    editedItemCategoriaDefault: {
      descricao: '',
      subcategoria: '',
      fkCategoria: ''
    },
    headersFaturaItems: [
      {
        text: 'Código de Barra',
        align: 'start',
        sortable: false,
        value: 'codBarra'
      },
      { text: 'Produto', value: 'produto' },
      { text: 'Unidade', value: 'unidade' },
      { text: 'Qtd', value: 'qtd' },
      { text: 'Preço de Unitário', value: 'precoUnitario' },
      { text: 'Custo Total', value: 'custoCompra' },
      { text: 'Delete', value: 'delete' }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },
    totalGeral () {
      let totalGeral = 0
      this.Produtos.forEach(element => {
        totalGeral += utilitarios.MoneyValueToInteger(element.custo)
      })
      return totalGeral
    }
    /* linhasVaziasEncontradas () {
      if (this.Produtos.filter(p => p.unidade === '').length) return true; return false
    },
    verificaProdutos () {
      let produtosTotal = 0
      this.Produtos.forEach(element => {
        produtosTotal += utilitarios.MoneyValueToInteger(element.custoCompra)
      })
      return produtosTotal
    },
    TotalInvalido () {
      let produtosTotal = 0
      this.Produtos.forEach(element => {
        produtosTotal += utilitarios.MoneyValueToInteger(element.custoCompra)
      })
      produtosTotal += this.valorDisponivel
      return (produtosTotal > ((this.editedItem.faturaCompra === null) ? 0 : this.editedItem.faturaCompra.totalFatura))
    } */

  },

  watch: {
    menuCompra (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val != null) this.tab = 0
      else this.tab = null
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.Categoriadispesas.filter(t => t.descricao.includes(val)).length) {
          this.Categoriadispesas = []
          return this.initializeProdutos(val)
        }
      }
      if (val.length >= 1) { return this.initializeProdutos(val) }
    },
    searchForn (val) {
      // Items have already been loaded
      if (val.length >= 2) {
      // Items have already been requested
        if (!this.Categoriadispesas.filter(t => t.descricao.includes(val)).length) {
          this.Categoriadispesas = []
          return this.PesquisarLotes(val)
        }
      }

      if (val.length >= 2) { return this.PesquisarLotes(val) }
    },
    searchNF (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.faturas.filter(t => t.referencia.includes(val)).length) {
          this.faturas = []
          return this.PesquisarFaturas(val)
        }
      }

      if (val.length >= 1) { return this.PesquisarFaturas(val) }
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    AddTabela () {
      if (this.$refs.form.validate()) {
        let params =
        {
          movimento: '',
          data: '',
          produto: '',
          categoria: '',
          fonte: '',
          tipo: '',
          formaPagamento: '',
          banco: '',
          conta: '',
          custo: ''
        }
        this.Produtos.push(params)
      }
    },

    remover (indice) {
      this.Produtos.splice(indice, 1)
      this.fornecedores = []
      this.mesmoLote = false
    },
    async initializeCategorias (searchBy) {
      try {
        //   let  payload =""
        this.isLoading_ = true
        this.Categoriadispesas = await axios
          .get('/categoriasFindAll/' + searchBy)
          .then(res => res.data)
        this.isLoading_ = false
      } catch (error) {
        this.isLoading_ = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async  PesquisarDispesas (val) {
      try {
        //   let  payload =""
        this.isLoadingLote = true
        this.Categoriadispesas = await axios
          .get('/despesasFind/' + val)
          .then(res => res.data)
        this.isLoadingLote = false
        this.Categoriadispesas.push({ descricao: 'Nova Categoria', icone: true, pkLote: -1 })
      } catch (error) {
        this.isLoadingLote = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async  Listagem_descricao () {
      try {
        //   let  payload =""
        this.overlay = true
        this.Categoriadispesas = await axios
          .get('/OutrasEntradasDescricao')
          .then(res => res.data)
        this.overlay = false
        this.Categoriadispesas.push({ descricao: 'Nova Descricao', icone: true, pkDispesa: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    SelecionaBanco (indice) {
      let objBanco = this.Produtos[indice].banco
      if (objBanco.pkBanco <= 0) {
        this.$router.push('Novo-banco')
      } else {
        this.InitializeContas(objBanco.pkBanco)
      }
    },
    async  InitializeContas (pkBanco) {
      try {
        //   let  payload =""
        this.overlay = true
        this.contas = await axios
          .get('/contasFindAll/' + pkBanco)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  Listagem_formasPagamento () {
      try {
        //   let  payload =""
        this.overlay = true
        this.formaPagamentos = await axios
          .get('/meiosPagamento')
          .then(res => res.data)
        this.overlay = false
        // this.formaPagamentos.push({ descricao: 'Nova Forma Pagamento', icone: true, pkFormaPagamento: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  Listagem_Bancos () {
      try {
        //   let  payload =""
        this.overlay = true
        this.bancos = await axios
          .get('/bancosFindAll')
          .then(res => res.data)
        this.overlay = false
        this.bancos.push({ nome: 'Novo Banco', icone: true, pkBanco: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  Listagem_Fontes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.fontes = await axios
          .get('/subcategoriaFindAll')
          .then(res => res.data)
        this.overlay = false
        this.subcategorias.push({ descricao: 'Nova Fonte', icone: true, pkFonte: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async Listagem_tiposDescontos_recentes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.tiposDispesas = await axios
          .get('/tiposDispesasFindAll')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async  CarregaCategorias () {
      try {
        //   let  payload =""
        this.overlay = true
        this.Categoriadispesas = await axios
          .get('/categoriasFindAll')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaCategoria (indice) {
      let categoria = this.Produtos[indice].categoria
      if (categoria !== null) {
        if (categoria.pkDispesa < 0) {
          this.showLoteModal = true
          this.Produtos[indice].categoria = null
          this.Categoriadispesas = []
        } else {
          this.pkCategoria = categoria.pkCategoria
          console.log(this.pkCategoria)
        }
      }
    },

    SelecionaFormaPagamento (indice) {
      let objPagamento = this.Produtos[indice].formaPagamento
      if (objPagamento.idMeioPagamento === 1) {
        this.disabilitaBanco = true
        this.Produtos[indice].banco = ''
        this.ruleRequiredBanco = ''
        this.cor = '#ccc'
      } else {
        this.disabilitaBanco = false
        this.cor = '#ffff99'
      }
    },

    SelecionaSubCategoria (indice) {
      let subcategoria = this.Produtos[indice].subcategoria
      if (subcategoria !== null) {
        if (subcategoria.pkSubcategoria < 0) {
          this.Produtos[indice].subcategoria = ''
          this.subcategorias = []
          this.dialogSubcategoria = true
        }
      }
    },

    showAlertValorCompraAtingida () {
      this.alert = true
      this.colorAlert = 'color:red;'
      this.iconAlert = 'warning'
      this.alertType = 'warning'
      this.msgAlert = 'Valor de compra atingido!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    showAlertSucess (msg) {
      this.alert = true
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 1000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    async  saveDescricao () {
      if (this.$refs.formLote.validate()) {
        let params =
          {
            pkCategoria: 0,
            descricao: this.editedItemCategoria.descricao
          }

        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/descricaoInsertOrUpdate', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            this.alertLote = true
            setTimeout(() => {
              this.alertLote = false
              this.showLoteModal = false
            }, 1000)
            this.limparLoteFields()
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async  saveSubcategoria () {
      if (this.$refs.formLote.validate()) {
        let params =
          {
            pkFonte: 0,
            descricao: this.editedItemCategoria.subcategoria
          }

        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/SubcategoriaInsertOrUpdate', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            this.alertLote = true
            setTimeout(() => {
              this.alertLote = false
              this.showLoteModal = false
            }, 1000)
            this.limparLoteFields()
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    Limpar () {
      this.editedItem = this.editedItemDefault
    },

    limparLoteFields () {
      this.editedItemCategoria = Object.assign(this.editedItemCategoria, this.editedItemCategoriaDefault)
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },

    SelecionaCategoriaFromSub () {

    },
    FecharSubDialog () {
      this.categoriaSelecionada = ''
      this.dialogSubcategoria = false
    },
    async  Concluir () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            pkDispesa: 0,
            dispesas: this.Produtos
          }
          // this.overlay = true
        console.log(params)
        try {
          //   let  payload =""
          let msg = await axios
            .post('/DispesaInsertOrUpdate', params)
            .then(res => res.data)
          if (msg) {
            setTimeout(() => {
              this.overlay = false
              this.showAlertSucess('Dispesa registrada com sucesso!')
              this.valorFatura = 0
              this.Produtos = []
            }, 2000)
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
